"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setComboChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucket_1 = require("../../constants/bucket");
var translations_1 = require("../translations");
var bucketHelper_1 = require("../bucketHelper");
var bucket_title_measures_column_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-measures-column.svg"));
var bucket_title_measures_line_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-measures-line.svg"));
var bucket_title_measures_area_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-measures-area.svg"));
var bucket_title_view_column_line_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-view-column-line.svg"));
var bucket_title_view_column_area_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-view-column-area.svg"));
var bucket_title_view_line_area_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-view-line-area.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/column/bucket-title-view.svg"));
var bucket_title_view_line_line_svg_1 = tslib_1.__importDefault(require("../../assets/combo/bucket-title-view-line-line.svg"));
var bucket_title_view_svg_2 = tslib_1.__importDefault(require("../../assets/area/bucket-title-view.svg"));
var uiConfig_1 = require("../../constants/uiConfig");
var COLUMN = sdk_ui_1.VisualizationTypes.COLUMN, LINE = sdk_ui_1.VisualizationTypes.LINE, AREA = sdk_ui_1.VisualizationTypes.AREA;
var MEASURE_BUCKET_ICONS = (_a = {},
    _a[COLUMN] = bucket_title_measures_column_svg_1.default,
    _a[LINE] = bucket_title_measures_line_svg_1.default,
    _a[AREA] = bucket_title_measures_area_svg_1.default,
    _a);
var VIEW_BY_ICONS = (_b = {},
    _b[COLUMN + "-" + COLUMN] = bucket_title_view_svg_1.default,
    _b[COLUMN + "-" + LINE] = bucket_title_view_column_line_svg_1.default,
    _b[COLUMN + "-" + AREA] = bucket_title_view_column_area_svg_1.default,
    _b[LINE + "-" + COLUMN] = bucket_title_view_column_line_svg_1.default,
    _b[LINE + "-" + LINE] = bucket_title_view_line_line_svg_1.default,
    _b[LINE + "-" + AREA] = bucket_title_view_line_area_svg_1.default,
    _b[AREA + "-" + COLUMN] = bucket_title_view_column_area_svg_1.default,
    _b[AREA + "-" + LINE] = bucket_title_view_line_area_svg_1.default,
    _b[AREA + "-" + AREA] = bucket_title_view_svg_2.default,
    _b);
function setCanStackInPercent(uiConfig, secondaryChartType, isDualAxis) {
    var canStackInPercent = !(isDualAxis === false && sdk_ui_charts_1.isLineChart(secondaryChartType));
    set_1.default(uiConfig, "optionalStacking.canStackInPercent", canStackInPercent);
}
function setComboChartUiConfig(referencePoint, intl, visualizationType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    var measureBuckets = bucketHelper_1.getBucketsByNames(referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets, [
        sdk_ui_1.BucketNames.MEASURES,
        sdk_ui_1.BucketNames.SECONDARY_MEASURES,
    ]);
    var chartTypes = [
        (_c = (_b = (_a = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.primaryChartType) !== null && _c !== void 0 ? _c : COLUMN,
        (_f = (_e = (_d = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.properties) === null || _d === void 0 ? void 0 : _d.controls) === null || _e === void 0 ? void 0 : _e.secondaryChartType) !== null && _f !== void 0 ? _f : LINE,
    ];
    var updatedUiConfig = bucketHelper_1.setBucketTitles(referencePointConfigured, visualizationType, intl);
    var isDualAxis = (_j = (_h = (_g = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.properties) === null || _g === void 0 ? void 0 : _g.controls) === null || _h === void 0 ? void 0 : _h.dualAxis) !== null && _j !== void 0 ? _j : true;
    setCanStackInPercent(updatedUiConfig, chartTypes[1], isDualAxis);
    measureBuckets.forEach(function (bucket, index) {
        var _a;
        var type = chartTypes[index];
        var localIdentifier = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        var subtitle = translations_1.getTranslation("dashboard.bucket.combo.subtitle." + type, intl);
        set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "subtitle"], subtitle);
        set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "icon"], MEASURE_BUCKET_ICONS[type]);
    });
    set_1.default(updatedUiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], VIEW_BY_ICONS[chartTypes.join("-")]);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, updatedUiConfig);
    return referencePointConfigured;
}
exports.setComboChartUiConfig = setComboChartUiConfig;
//# sourceMappingURL=comboChartUiConfigHelper.js.map